const IDS = {
    INSURANCE_TYPE: 'insuranceType',
    FRANCHISE: 'franchise',
    INSURANCE_SUM: 'insuranceSum',
    CARGO_TYPE: 'cargoType',
    CARGO_PACKAGING: 'cargoPackaging',
    CARGO_LOADING_TYPE: 'cargoLoadingType',
    DISTANCE_AREA: 'distanceArea',
    DISTANCE_COUNT: 'distanceCount',
    DISTANCE_FROM: 'distanceFrom',
    DISTANCE_TO: 'distanceTo',
    TRANSPORT_GUARD: 'transportGuard',
    TRANSPORT_SHIPPING: 'transportShipping',
    TRANSPORT_TYPE: 'transportType',
    TRANSPORT_STORAGE: 'transportStorage',
    TRANSPORT_LOADING_COUNT: 'transportReload',
    TRANSPORT_LONG_DELIVERY: 'transportLongDelivery',
    CONTACT_PHONE: 'phone',
    CONTACT_NAME: 'contactName',
    CONTACT_COMPANY: 'contactCompany',
    CALCULATION_ID: 'calculationId',
    EMAIL: 'email',
    AGREEMENT_WITH_PROTECTION_POLICY: 'agreementWithProtectionPolicy',
    AGREEMENT_WITH_RULES: 'agreementWithRules',
}

export default IDS
